import type {
  ContentServiceResult,
  ContentServiceDocument,
  Teaser,
  CssClassMap,
  FetchTeaserServiceConfig,
} from './utils/interfaces';

export const mapContentServiceResultToTeaserList = (
  result: ContentServiceResult,
): Teaser[] => {
  const data = result?.caas;
  if (!data?.documents) {
    return;
  }

  const teasers = data?.documents;
  return teasers
    .filter(
      (item: ContentServiceDocument) =>
        item.document.data.mediaType != 'IMAGE' ||
        item.document.data.keyvisual_image.image,
    )
    .map((item: ContentServiceDocument) => {
      const data = item.document.data;
      const media = {};
      const label = data.label ?? data.title;
      let altText = label;

      if (data.mediaType == 'IMAGE') {
        media['imageDerivates'] = data.keyvisual_image.image;
        altText = data.keyvisual_image?.alttext ?? label;
      } else if (data.mediaType == 'YOUTUBE') {
        media['youtubeThumbnail'] = data['keyvisual_videothumbnail'];
      } else if (data.mediaType == 'VIDEO') {
        media['videos'] = data.videos;
        media['imageDerivates'] = data.keyvisual_image?.image;
        altText = data.keyvisual_image?.alttext ?? label;
      }

      return {
        badge: data.badge,
        altText: altText,
        url: data.url,
        headline: label,
        uid: data.id,
        keywords: data.tags,
        rubrics: data.rubrics,
        detail: data.description,
        ...media,
      } as Teaser;
    });
};

export const moreContentButtonClassMap = (
  teaserResult: ContentServiceResult,
  loadDataConfig: FetchTeaserServiceConfig,
): CssClassMap => {
  return {
    ['more-button-wrapper']: true,
    ['display-none']: !checkLoadMoreContent(teaserResult, loadDataConfig),
  };
};

export const checkLoadMoreContent = (
  teaserResult: ContentServiceResult,
  loadDataConfig: FetchTeaserServiceConfig,
): boolean => {
  if (!teaserResult?.caas) {
    return false;
  }
  const totalPages = Math.ceil(
    teaserResult.caas.total / loadDataConfig.responseTeaserCount,
  );

  return loadDataConfig.responsePage < totalPages;
};
